import { Reducer } from 'redux'
import { KANBAN, TYPES } from './types'
import { AnyAction } from 'models/types'
import { StatusChamadaEnum } from 'models/atendimento/types'

const INITIAL_STATE: KANBAN = {
  kanbanData: {
    nome: '',
    descricao: '',
    centroCustoId: '',
    pipelineId: '',
    site: false,
    columns: []
  },
  loadingKanban: false,
  filtros: {
    centroCustoId: null,
    pipelineId: null,
    isArchived: false
  },
  optionsSelect: {
    centrosCusto: [],
    pipelines: [],
    consultores: [],
    convenios: [],
    perfis: [],
    motivosPerda: [],
    tiposAgendamento: []
  },
  loadingSelect: {
    centrosCusto: false,
    pipelines: false,
    consultores: false,
    convenios: false,
    perfis: false,
    motivosPerda: false,
    tiposAgendamento: false
  },
  modalKanban: {
    isOpen: false,
    informacoes: {
      pipelineEtapaClienteId: '',
      clienteId: '',
      nome: '',
      cpf: '',
      ddd: null,
      numero: null,
      telefoneId: null,
      email: null,
      profissao: null,
      ordem: null,
      valorOportunidade: 0,
      perfis: null,
      dataCriacao: '',
      dataMovimentacao: null,
      consultorId: '',
      nomeConsultor: '',
      origem: null,
      anotacoes: [],
      iteracoes: [],
      situacao: null
    },
    consultor: {
      id: '',
      nome: ''
    },
    consultores: [],
    anotacao: ''
  },
  bigNumbers: {
    totalLeads: 0,
    totalLeadsAtraso: 0,
    totalNovosLeads: 0,
    totalTarefasConsultorHoje: 0
  },
  modalCpf: {
    isOpen: false,
    cpf: ''
  },
  modalCadastroCliente: {
    isOpen: false,
    register: {
      nome: '',
      cpf: '',
      dataNascimento: '',
      ddd: '',
      telefone: '',
      matricula: '',
      perfilId: null,
      convenioId: '',
      margem: '',
      margemCartao: '',
      indexTabCliente: 0,
      numeroNit: ''
    },
    invalids: {
      nome: {
        invalid: false,
        message: ''
      },
      cpf: {
        invalid: false,
        message: ''
      },
      dataNascimento: {
        invalid: false,
        message: ''
      },
      ddd: {
        invalid: false,
        message: ''
      },
      telefone: {
        invalid: false,
        message: ''
      },
      matricula: {
        invalid: false,
        message: ''
      },
      perfilId: {
        invalid: false,
        message: ''
      },
      numeroNit: {
        invalid: false,
        message: ''
      }
    }
  },
  modalConfirmacao: {
    isOpen: false
  },
  coordenador: false,
  movimentacaoPendente: null,
  isOpenModalMotivo: false,
  motivoMovimentacao: {
    observacao: '',
    motivoId: '',
    pipelineEtapaClienteId: ''
  },
  inboxesChatwoot: [],
  agentesChatwoot: [],
  isModalChatwootOpen: false,
  agenteChatwootSelected: null,
  inboxChatwootSelected: null,
  isOpenModalAgendamento: false,
  agendamento: {
    pipelineEtapaClienteId: '',
    dataAtendimento: '',
    horario: '',
    tipoAgendamentoId: '',
    observacao: '',
    ddd: '',
    telefone: ''
  },
  discagem: {
    isOpen: false,
    numeroDiscado: null,
    cpfDiscando: null,
    statusChamada: StatusChamadaEnum.naoIniciado
  }
}

const reducer: Reducer<KANBAN, AnyAction> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case TYPES.SET_KANBAN:
      return { ...state, kanbanData: action.value }
    case TYPES.SET_LOADING_KANBAN:
      return { ...state, loadingKanban: action.value }
    case TYPES.SET_OPTIONS_SELECT:
      return {
        ...state,
        optionsSelect: { ...state.optionsSelect, [action.field]: action.value }
      }
    case TYPES.SET_LOADING_SELECT:
      return {
        ...state,
        loadingSelect: {
          ...state.loadingSelect,
          [action.field]: action.value
        }
      }
    case TYPES.SET_FILTROS_FIELD:
      return {
        ...state,
        filtros: { ...state.filtros, [action.field]: action.value }
      }
    case TYPES.SET_IS_OPEN_MODAL_KANBAN:
      return {
        ...state,
        modalKanban: { ...state.modalKanban, isOpen: action.value }
      }
    case TYPES.SET_INFORMACOES_MODAL_KANBAN:
      return {
        ...state,
        modalKanban: { ...state.modalKanban, informacoes: action.value }
      }
    case TYPES.SET_CONSULTOR_MODAL_KANBAN:
      return {
        ...state,
        modalKanban: { ...state.modalKanban, consultor: action.value }
      }
    case TYPES.SET_CONSULTORES_MODAL_KANBAN:
      return {
        ...state,
        modalKanban: { ...state.modalKanban, consultores: action.value }
      }
    case TYPES.SET_INFORMACOES_CARD_KANBAN_FIELD:
      return {
        ...state,
        modalKanban: {
          ...state.modalKanban,
          informacoes: {
            ...state.modalKanban.informacoes,
            [action.field]: action.value
          }
        }
      }
    case TYPES.SET_ANOTACAO_CARD_KANBAN:
      return {
        ...state,
        modalKanban: {
          ...state.modalKanban,
          anotacao: action.value
        }
      }
    case TYPES.SET_BIG_NUMBERS:
      return {
        ...state,
        bigNumbers: action.value
      }
    case TYPES.SET_IS_OPEN_MODAL_CADASTRO_CLIENTE:
      return {
        ...state,
        modalCadastroCliente: {
          ...state.modalCadastroCliente,
          isOpen: action.value
        }
      }
    case TYPES.SET_REGISTER_MODAL_CADASTRO_CLIENTE_FIELD:
      return {
        ...state,
        modalCadastroCliente: {
          ...state.modalCadastroCliente,
          register: {
            ...state.modalCadastroCliente.register,
            [action.field]: action.value
          }
        }
      }
    case TYPES.SET_REGISTER_MODAL_CADASTRO_CLIENTE:
      return {
        ...state,
        modalCadastroCliente: {
          ...state.modalCadastroCliente,
          register: action.value
        }
      }
    case TYPES.CLEAN_REGISTER_MODAL_CADASTRO_CLIENTE:
      return {
        ...state,
        modalCadastroCliente: {
          ...state.modalCadastroCliente,
          register: INITIAL_STATE.modalCadastroCliente.register,
          invalids: INITIAL_STATE.modalCadastroCliente.invalids
        }
      }
    case TYPES.SET_INVALIDS_REGISTER_MODAL_CADASTRO_CLIENTE_FIELD:
      return {
        ...state,
        modalCadastroCliente: {
          ...state.modalCadastroCliente,
          invalids: {
            ...state.modalCadastroCliente.invalids,
            [action.field]: action.value
          }
        }
      }
    case TYPES.CLEAN_INVALIDS_REGISTER_MODAL_CADASTRO_CLIENTE:
      return {
        ...state,
        modalCadastroCliente: {
          ...state.modalCadastroCliente,
          invalids: INITIAL_STATE.modalCadastroCliente.invalids
        }
      }
    case TYPES.SET_IS_OPEN_MODAL_CPF:
      return {
        ...state,
        modalCpf: { ...state.modalCpf, isOpen: action.value }
      }
    case TYPES.SET_CPF_MODAL_CPF:
      return {
        ...state,
        modalCpf: { ...state.modalCpf, cpf: action.value }
      }
    case TYPES.SET_IS_OPEN_MODAL_CONFIRMACAO:
      return {
        ...state,
        modalConfirmacao: {
          ...state.modalConfirmacao,
          isOpen: action.value
        }
      }
    case TYPES.SET_COORDENADOR:
      return {
        ...state,
        coordenador: action.value
      }
    case TYPES.SET_MOVIMENTACAO_PENDENTE:
      return {
        ...state,
        movimentacaoPendente: action.value
      }
    case TYPES.SET_IS_OPEN_MODAL_MOTIVO:
      return {
        ...state,
        isOpenModalMotivo: action.value
      }
    case TYPES.SET_MOTIVO_MOVIMENTACAO:
      return {
        ...state,
        motivoMovimentacao: action.value
      }
    case TYPES.CLEAN_MOTIVO_MOVIMENTACAO:
      return {
        ...state,
        motivoMovimentacao: INITIAL_STATE.motivoMovimentacao
      }
    case TYPES.TOGGLE_CHATWOOT_MODAL:
      return {
        ...state,
        isModalChatwootOpen: action.value
      }
    case TYPES.SET_AGENTES_CHATWOOT:
      return {
        ...state,
        agentesChatwoot: action.value
      }
    case TYPES.SET_INBOXES_CHATWOOT:
      return {
        ...state,
        inboxesChatwoot: action.value
      }
    case TYPES.SET_INBOX_CHATWOOT_SELECTED:
      return {
        ...state,
        inboxChatwootSelected: action.value
      }
    case TYPES.SET_AGENTE_CHATWOOT_SELECTED:
      return {
        ...state,
        agenteChatwootSelected: action.value
      }
    case TYPES.CLEAN_MODAL_CHATWOOT:
      return {
        ...state,
        agenteChatwootSelected: '',
        inboxChatwootSelected: ''
      }
    case TYPES.SET_IS_OPEN_MODAL_AGENDAMENTO:
      return {
        ...state,
        isOpenModalAgendamento: action.value
      }
    case TYPES.SET_AGENDAMENTO:
      return {
        ...state,
        agendamento: action.value
      }
    case TYPES.CLEAN_AGENDAMENTO:
      return {
        ...state,
        agendamento: INITIAL_STATE.agendamento
      }
    case TYPES.SET_MODAL_DISCAGEM:
      return {
        ...state,
        discagem: action.value
      }
    case TYPES.CLEAN_MODAL_DISCAGEM:
      return {
        ...state,
        discagem: INITIAL_STATE.discagem
      }
    default:
      return state
  }
}

export default reducer
